@if (flags.loading) {
  <mat-progress-bar mode="indeterminate" [class.iosProgress]="utils.ios()"></mat-progress-bar>
}
<app-add-conversation></app-add-conversation>
<div class="messages-container" [class.ios]="utils.ios()" [class.android]="utils.android()" (swiperight)="router.navigateByUrl('/dashboard')" (swipeleft)="router.navigateByUrl('/' + (user?.username || ''))">
  <button type="button" class="addBtn" [class.ios]="utils.ios()" [class.android]="utils.android()" (click)="clickAddConversation()" aria-label="New message">
    @if (!user?.app_state?.startConversation) {
      <mat-icon>add</mat-icon>
    }
    @if (user?.app_state?.startConversation) {
      <mat-icon>close</mat-icon>
    }
  </button>
  <div class="profile">
    <div class="messages-header">
      <h1 class="page-title">Messages</h1>
    </div>

    @for (conversation of conversations; track conversation) {
      <div class="item" [style.background-color]="conversation?.meta?.to?.color + '85'"
        [class.unread]="conversation?.unread_count > 0">
        <div fxlayout="row" (click)="selectConversation(conversation)" [routerLink]="'/messages/'+ conversation.id">
          <div class="left">
            <div class="border" [style.border-color]="conversation?.meta?.to?.color" >
              @if (conversation?.meta?.to?.thumbnail?.sm) {
                <button (click)="utils.sound('click-face')" [style.background-image]="getProfileBackground($safeNavigationMigration(conversation?.meta?.to))">
                  @if (conversation?.meta?.to?.is_premium && !conversation?.meta?.to?.is_verified) {
                    <mat-icon class="premium" [style.color]="conversation?.meta?.to?.color">star</mat-icon>
                  }
                  @if (conversation?.meta?.to?.is_premium && conversation?.meta?.to?.is_verified) {
                    <mat-icon class="premium" [style.color]="conversation?.meta?.to?.color">fingerprint</mat-icon>
                  }
                  @if (conversation?.meta?.to?.meta?.is_new) {
                    <mat-icon class="new" [style.color]="conversation?.meta?.to?.color">fiber_new</mat-icon>
                  }
                  @if (conversation?.unread_count > 0) {
                    <div class="counter" [class.lightMode]="$safeNavigationMigration(conversation?.meta?.to?.color)|isLight" [style.background-color]="conversation?.meta?.to?.color">{{conversation?.unread_count}}</div>
                  }
                </button>
              }
              @if (!conversation?.meta?.to?.thumbnail?.sm) {
                <div class="noImage" [style.border-color]="conversation?.meta?.to?.color"  [style.color]="conversation?.meta?.to?.color + '80'">{{$safeNavigationMigration(conversation?.meta?.to?.full_name)|slice:0:2}}</div>
              }
            </div>
          </div>
          <div fxFlex>
            @if (conversation?.meta?.names != '') {
              <h2>{{conversation?.meta?.names }}</h2>
            }
            @if (conversation?.meta?.names == '') {
              <h2>Mystery</h2>
            }
            <p>{{$safeNavigationMigration(conversation?.last_message)|slice:0:25 }}...</p>
            <h6>{{ $safeNavigationMigration(conversation?.last_activity)|timeAgo}} ago</h6>
          </div>
        </div>
      </div>
    }

    @if (flags.noResultsConversations && conversations != null && conversations?.length <= 0) {
      <div class="item" (click)="clickAddConversation()">
        <div fxlayout="row">
          <div fxFlex class="noMessages">
            <br />
            <h2>No messages, yet!</h2>
            <p>create a new one?</p>
            <br />
          </div>
        </div>
      </div>
    }
  </div>
</div>